<div #container class="nc-galaxy-canvas-container"></div>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>